let namespace;

const getItem = key => {
  try {
    return JSON.parse(localStorage.getItem(namespace))[key];
  } catch (e) {
    return null;
  }
};

const setItem = (key, value) => {
  try {
    const cache = JSON.parse(localStorage.getItem(namespace)) || {};
    cache[key] = value;
    localStorage.setItem(namespace, JSON.stringify(cache));
  } catch (e) {}
};

const removeItem = key => {
  try {
    const cache = JSON.parse(localStorage.getItem(namespace));
    delete cache[key];
    localStorage.setItem(namespace, JSON.stringify(cache));
  } catch (e) {}
};

const getAppCache = () => {
  try {
    return JSON.parse(localStorage.getItem(namespace));
  } catch (e) {}
};

const clearAppCache = () => {
  try {
    localStorage.removeItem(namespace);
  } catch (e) {}
};

module.exports = ({ dataVersion, email }) => {
  if (dataVersion === undefined || email === undefined) {
    throw new TypeError(
      "You must pass 'dataVersion' and 'email' fields in your input object"
    );
  }

  namespace = window.location.pathname.split("/")[1];

  if (
    dataVersion !== getItem("DATA_VERSION") ||
    email !== getItem("USER_EMAIL")
  ) {
    clearAppCache();
    setItem("DATA_VERSION", dataVersion);
    setItem("USER_EMAIL", email);
  }
  return {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    getAppCache: getAppCache,
    clearAppCache: clearAppCache
  };
};
